export default __webpack_public_path__ + "static/media/Luciana Viacava_.829745b4.png";